import { useEffect } from "react";
import { useNavigate, useLocation, Outlet } from "react-router-dom";
import { Tabs, Tab, Box, Typography } from "@mui/material";

const tabs = [
  { label: "Timesheets", path: "/tasks/timesheets" },
  { label: "Leave Requests", path: "/tasks/leaverequests" },
];

export const Tasks = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const currentTabIndex = tabs.findIndex((tab) =>
    location.pathname.startsWith(tab.path)
  );

  useEffect(() => {
    if (currentTabIndex === -1) {
      navigate("/tasks/timesheets", { replace: true });
    }
  }, [currentTabIndex, navigate]);

  const handleTabChange = (event, newValue) => {
    navigate(tabs[newValue].path);
  };

  return (
    <Box className="tgs-content">
      <Box className="tasksContainer">
        <Typography variant="h2" sx={{ mb: 2 }}>
          Tasks
        </Typography>
        <Tabs
          value={currentTabIndex === -1 ? 0 : currentTabIndex}
          onChange={handleTabChange}
          textColor="primary"
          indicatorColor="primary"
          variant="standard"
          sx={{
            minHeight: "28px",
            height: "28px",
            "& .MuiTabs-flexContainer": {
              minHeight: "28px",
            },
            "& .MuiTabs-indicator": {
              height: "2px",
            },
          }}
        >
          {tabs.map((tab, index) => (
            <Tab
              key={index}
              label={tab.label.toUpperCase()}
              sx={{
                minHeight: "28px",
                height: "28px",
                fontSize: "0.95rem",
                fontWeight: 600,
                letterSpacing: "0.05em",
                textTransform: "none",
                px: 1.2,
                py: 0,
                minWidth: 0,
                lineHeight: 1.2,
              }}
              disableRipple
            />
          ))}
        </Tabs>

        <Box sx={{ mt: 3 }}>
          <Outlet />
        </Box>
      </Box>
    </Box>
  );
};